/**
 * The internal dependencies.
 */
import createAction from 'lib/helpers/create-action';

export const authSuccess = createAction('AUTH@@SUCCESS');
export const authSetUserClaims = createAction('AUTH@@SET_USER_CLAIMS');
export const authReset = createAction('AUTH@@RESET');
